<script>
import AdminLayout from '@layouts/admin-main'
import ContractNav from '@components/admin/contract-nav'
import ContractAgreementList from '@components/admin/contract-agreement-list'

export default {
  page: {
    title: 'Admin::ContractAgreementList',
    meta: [{ name: 'description', content: 'Admin::ContractAgreementList' }],
  },
  components: {
    AdminLayout,
    ContractNav,
    ContractAgreementList,
  },
}
</script>

<template>
  <AdminLayout>
    <ContractNav></ContractNav>
    <ContractAgreementList></ContractAgreementList>
  </AdminLayout>
</template>
